import { render } from "./doi.vue?vue&type=template&id=1a9c68f8&scoped=true&ts=true"
import script from "./doi.vue?vue&type=script&lang=ts"
export * from "./doi.vue?vue&type=script&lang=ts"

import "./doi.vue?vue&type=style&index=0&id=1a9c68f8&scoped=true&lang=scss"

import exportComponent from "/usr/src/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a9c68f8"]])

export default __exports__